import { createSlice } from '@reduxjs/toolkit';

export const municipalySlice = createSlice({
  name: 'municipalies',
  initialState: {
    municipaly_list: [],
    municipaly_list_select: [],
  },
  reducers: {
    setMunicipalysRedux: (state, { payload }) => {
      state.municipaly_list_select = payload;
    },
    setMunicipalysSelectRedux: (state, { payload }) => {
      state.municipaly_list_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMunicipalysRedux, setMunicipalysSelectRedux } = municipalySlice.actions;
